import { CommonEnums } from '../../common.enums'
import { FilterSearchObject } from './filter.search.object';
import { ObjectBase } from '../object.base';
import { ListUtil } from '../../utils/list.util';

export class FilterObject extends ObjectBase {
   obj_Cd: string;
   objNm: string;
   startLimit: number;
   endLimit: number;
   fldr_Id: number;
   start_Ts: string;
   end_Ts: string;
   searchText: string;
   reUsableFlag: string;
   filterSearchObjects: Array<FilterSearchObject>;
   dbTyp_Id: number;
   org_Id: number;
   connNm: string;
   aliasNm: string;
   offsetInSeconds: number;
   conn_Ids: Array<string>;
   conn_Db_Ids: Array<number>
   dbTyp_Ids: Array<number>;
   fldr_Ids: Array<string>;
   openDOFlg: boolean;
   fldrReusableFlag: string;
   defaultFlag:string;
   aliasNmList:Array<string>;
   dxMp_Id:number;

    constructor() {
        super();

        this.obj_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.objNm = CommonEnums.defaults.STRING_EMPTY;
        this.startLimit = 1;
        this.endLimit = CommonEnums.defaults.LONG_VAL;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.start_Ts = null;
        this.end_Ts = null;
        this.searchText = CommonEnums.defaults.STRING_EMPTY;
        this.reUsableFlag = CommonEnums.reusableFlag.NO;
        this.dbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.org_Id = CommonEnums.defaults.LONG_VAL;
        this.connNm = CommonEnums.defaults.STRING_EMPTY;
        this.aliasNm = CommonEnums.defaults.STRING_EMPTY;
        this.offsetInSeconds = 0;
        this.openDOFlg = false;
        this.fldrReusableFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.defaultFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.dxMp_Id =CommonEnums.defaults.LONG_VAL;


        this.filterSearchObjects = new Array<FilterSearchObject>();
        this.conn_Ids = new Array<string>();
        this.conn_Db_Ids = new Array<number>();
        this.dbTyp_Ids = new Array<number>();
        this.fldr_Ids = new Array<string>();
        this.aliasNmList = new Array<string>();
        
    }

    static parse(filterObjectTmp: FilterObject): FilterObject {
        let filterObject: FilterObject = new FilterObject();
        filterObject.copyFrom(filterObjectTmp);
        return filterObject;
    }

    copy(): FilterObject {
        let filterObjectTmp: FilterObject = new FilterObject();

        filterObjectTmp.obj_Cd = this.obj_Cd;
        filterObjectTmp.objNm = this.objNm;
        filterObjectTmp.startLimit = this.startLimit;
        filterObjectTmp.endLimit = this.endLimit;
        filterObjectTmp.fldr_Id = this.fldr_Id;
        filterObjectTmp.start_Ts = this.start_Ts;
        filterObjectTmp.end_Ts = this.end_Ts;
        filterObjectTmp.searchText = this.searchText;
        filterObjectTmp.reUsableFlag = this.reUsableFlag;
        filterObjectTmp.dbTyp_Id = this.dbTyp_Id;
        filterObjectTmp.org_Id = this.org_Id;
        filterObjectTmp.connNm = this.connNm;
        filterObjectTmp.aliasNm = this.aliasNm;
        filterObjectTmp.offsetInSeconds = this.offsetInSeconds;
        filterObjectTmp.openDOFlg = this.openDOFlg;
        filterObjectTmp.fldrReusableFlag = this.fldrReusableFlag;
        filterObjectTmp.defaultFlag = this.defaultFlag;
        filterObjectTmp.dxMp_Id = this.dxMp_Id;
        

    //    FilterObjectsUtil.getInstance().copyFromFilterSearchObjects( this.filterSearchObjects, filterObjectTmp.filterSearchObjects );

        let listUtil: ListUtil = ListUtil.getInstance();
        filterObjectTmp.conn_Ids = listUtil.copy( this.conn_Ids );
        filterObjectTmp.conn_Db_Ids = listUtil.copy( this.conn_Db_Ids );
        filterObjectTmp.dbTyp_Ids = listUtil.copy( this.dbTyp_Ids );
        filterObjectTmp.fldr_Ids = listUtil.copy( this.fldr_Ids );

        return filterObjectTmp;
    }

    copyFrom( filterObjectTmp: FilterObject ): void {
        this.dxMp_Id = filterObjectTmp.dxMp_Id;
        this.obj_Cd = filterObjectTmp.obj_Cd;
        this.objNm = filterObjectTmp.objNm;
        this.startLimit = filterObjectTmp.startLimit;
        this.endLimit = filterObjectTmp.endLimit;
        this.fldr_Id = filterObjectTmp.fldr_Id;
        this.start_Ts = filterObjectTmp.start_Ts;
        this.end_Ts = filterObjectTmp.end_Ts;
        this.searchText = filterObjectTmp.searchText;
        this.reUsableFlag = filterObjectTmp.reUsableFlag;
        this.dbTyp_Id = filterObjectTmp.dbTyp_Id;
        this.org_Id = filterObjectTmp.org_Id;
        this.connNm = filterObjectTmp.connNm;
        this.aliasNm = filterObjectTmp.aliasNm;
        this.offsetInSeconds = filterObjectTmp.offsetInSeconds;
        this.openDOFlg = filterObjectTmp.openDOFlg;
        this.fldrReusableFlag = filterObjectTmp.fldrReusableFlag;
        this.defaultFlag = filterObjectTmp.defaultFlag;
        

        let filterSearchObjectsMap: Map<string, FilterSearchObject> = new Map();

        for( let i: number = 0; i < this.filterSearchObjects.length; i++ ) {
            let filterSearchObject: FilterSearchObject = this.filterSearchObjects[i] as FilterSearchObject;
            filterSearchObjectsMap.set( filterSearchObject.obj_Cd, filterSearchObject );
        }

        ListUtil.getInstance().splice( this.filterSearchObjects );

        for( let i: number = 0; i < filterObjectTmp.filterSearchObjects.length; i++ ) {
            let filterSearchObjectTmp: FilterSearchObject = FilterSearchObject.parse( filterObjectTmp.filterSearchObjects[i] as FilterSearchObject );

            let filterSearchObject: FilterSearchObject = filterSearchObjectsMap.get( filterSearchObjectTmp.obj_Cd );
            if( filterSearchObject ) {
                filterSearchObject.copyFrom( filterSearchObjectTmp );
            } else {
                filterSearchObject = filterSearchObjectTmp.copy();
            }

            this.filterSearchObjects.push( filterSearchObject );
        }

        let listUtil: ListUtil = ListUtil.getInstance();
        listUtil.copyFrom( this.conn_Ids, filterObjectTmp.conn_Ids );
        listUtil.copyFrom( this.conn_Db_Ids, filterObjectTmp.conn_Db_Ids );
        listUtil.copyFrom( this.dbTyp_Ids, filterObjectTmp.dbTyp_Ids );
        listUtil.copyFrom( this.fldr_Ids, filterObjectTmp.fldr_Ids );
    }

    deSelectAll(): void {
        this.searchText = CommonEnums.defaults.STRING_EMPTY;

        for( let i: number = 0; i < this.filterSearchObjects.length; i++ ) {
            let filterSearchObject: FilterSearchObject = this.filterSearchObjects[i] as FilterSearchObject;
            
            if( filterSearchObject.selected ) {
                filterSearchObject.selected = false;
                filterSearchObject.deSelectAll();
            }
        }
    }
}